import { UserInformation } from "@partikelart/identity/data-access-user";
import { BackendReport, BauteilEntry, DashboardStatsData, UrlObject } from "@partikelart/portal/shared-typing";

export const userData: UserInformation = {
	name: "Max Mustermann",
	email: "max@muster-gmbh.de",
	activeSiteId: "00000000-0000-4000-8000-000000000010",
	siteOptions: [
		{
			siteId: "00000000-0000-4000-8000-000000000010",
			siteName: "Musterstadt Muster GmbH",
			accountId: "00000000-0000-4000-8000-000000000001",
		},
		{
			siteId: "00000000-0000-4000-8000-000000000011",
			siteName: "Paris Muster GmbH",
			accountId: "00000000-0000-4000-8000-000000000001",
		},
	],
};
export const reportData: Partial<BackendReport> = {
	Analysis_No: "12345",
	Component_No: "45678",
	Component: "Batteriezelle",
	Testing_Specification: "890123",
	Customer: "Muster GmbH",
	customer_no: "12345",
	Date_of_arrival: new Date(99, 11, 24),
	Date_of_Extraction: new Date(99, 11, 25),
	Date_of_Analysis: new Date(99, 11, 26),
	Filter_Type: "15 μm",
	filter_diameter: "22mm",
	Parts_on_Filter: 10,
	Component_Surface_Area_cm2: 1000,
	Weight_mg: 15,
	Scale: "10px/μm",
	Evaluated_diameter_mm: 22,
	occupancy: 0.25,
	woF_5_15: 2048,
	woF_15_25: 1024,
	woF_25_50: 512,
	woF_50_100: 256,
	woF_100_150: 128,
	woF_150_200: 64,
	woF_200_400: 32,
	woF_400_600: 16,
	woF_600_1000: 8,
	woF_gt_1000: 4,
	woF_200_300: 2,
	woF_300_400: 1,
	woF_400_500: 0,
	woF_500_600: 0,
	woF_600_700: 0,
	woF_700_800: 0,
	woF_800_900: 0,
	woF_900_1000: 0,
	woF_1000_1500: 0,
	woF_1500_2000: 0,
	woF_2000_2500: 0,
	woF_2500_3000: 0,
	woF_gt_3000: 0,
	All_5_15: 4096,
	All_15_25: 2048,
	All_25_50: 1024,
	All_50_100: 512,
	All_100_150: 256,
	All_150_200: 128,
	All_200_400: 64,
	All_400_600: 32,
	All_600_1000: 16,
	All_gt_1000: 8,
	All_200_300: 4,
	All_300_400: 2,
	All_400_500: 1,
	All_500_600: 0,
	All_600_700: 0,
	All_700_800: 0,
	All_800_900: 0,
	All_900_1000: 0,
	All_1000_1500: 0,
	All_1500_2000: 0,
	All_2000_2500: 0,
	All_2500_3000: 0,
	All_gt_3000: 0,
	Met_5_15: 10,
	Met_15_25: 9,
	Met_25_50: 8,
	Met_50_100: 7,
	Met_100_150: 6,
	Met_150_200: 5,
	Met_200_400: 4,
	Met_400_600: 3,
	Met_600_1000: 2,
	Met_gt_1000: 1,
	Met_200_300: 0,
	Met_300_400: 0,
	Met_400_500: 0,
	Met_500_600: 0,
	Met_600_700: 0,
	Met_700_800: 0,
	Met_800_900: 0,
	Met_900_1000: 0,
	Met_1000_1500: 0,
	Met_1500_2000: 0,
	Met_2000_2500: 0,
	Met_2500_3000: 0,
	Met_gt_3000: 0,

	woFNM_1L: 352,
	woFNM_1W: 42,
	woFNM_2L: 232,
	woFNM_2W: 31,
	woFNM_3L: 199,
	woFNM_3W: 40,
	woFNM_4L: 189,
	woFNM_4W: 39,
	woFNM_5L: 180,
	woFNM_5W: 37,
	Met_1L: 1001,
	Met_1W: 150,
	Met_2L: 840,
	Met_2W: 200,
	Met_3L: 740,
	Met_3W: 109,
	Met_4L: 640,
	Met_4W: 10,
	Met_5L: 606,
	Met_5W: 50,

	Fib_Fmax1_Fmax: 20,
	Fib_Fmax1_Lstr: 1000,
	Fib_Fmax2_Fmax: 25,
	Fib_Fmax2_Lstr: 850,

	Fib_Fmax_Sum_um: 1000,
	Fib_Stretched_Sum_um: 1000,
	woF_weighted_sum: 1000,
	All_weighted_sum: 1000,
	Met_weighted_sum: 1000,
	artsuch: "Musterbauteil",
	artnr: 890123,
	bemmem: "Saugextraktion",
	artbez1: "Werksnorm XY",
	artbez2: "- 23",

	zeichnr: "Musterbauteil",
	katseite: "Musterbauteil",
	zeichindex: "1234",
	ioResult: true,
	is_fallback: false,
	filtersize: "22mm",
	met_sum: 10000,
	nm_sum: 10000,
	fibers_sum: 10000,
};
export const bauteilbildData: unknown = {
	url: "http://localhost:4200/images/no_image.svg",
};

export const overviewData: DashboardStatsData = {
	berichte: 120,
	berichte_neu: 2,
	bauteile: 15,
	bauteile_neu: 1,
	lastComponentAddedAt: "2024-12-15T10:30:00.000Z",
	lastReportDate: "2025-04-17T15:03:00.000Z",
	nokRate: 3.2,
};

const baseReport: Partial<BackendReport> = {
	...reportData,
	Component_No: "45678",
	Component: "Batteriezelle",
	Testing_Specification: "890123",
	Customer: "Muster GmbH",
	customer_no: "12345",

	artsuch: "Musterbauteil",
	artnr: 890123,
	bemmem: "Saugextraktion",
	artbez1: "Werksnorm XY",
	artbez2: "- 23",

	zeichnr: "Musterbauteil",
	zeichindex: "1234",
	ioResult: true,
	is_fallback: false,
	filtersize: "22mm",
	katseite: "Musterbauteil",
};

export const overviewTableData: Partial<BackendReport>[] = [
	{
		...baseReport,
		Analysis_No: "12345",
		Date_of_arrival: new Date(99, 11, 24),
		Date_of_Extraction: new Date(99, 11, 25),
		Date_of_Analysis: new Date(99, 11, 26),
		new: true,
	},
	{
		...baseReport,
		Analysis_No: "12346",
		Date_of_arrival: new Date(99, 11, 24),
		Date_of_Extraction: new Date(99, 11, 25),
		Date_of_Analysis: new Date(99, 11, 26),
		new: true,
	},
	{
		...baseReport,
		Analysis_No: "12347",
		Date_of_arrival: new Date(99, 11, 24),
		Date_of_Extraction: new Date(99, 11, 25),
		Date_of_Analysis: new Date(99, 11, 26),
	},
	{
		...baseReport,
		Analysis_No: "12348",
		Date_of_arrival: new Date(99, 11, 24),
		Date_of_Extraction: new Date(99, 11, 25),
		Date_of_Analysis: new Date(99, 11, 26),
	},
	{
		...baseReport,
		Analysis_No: "12349",
		Date_of_arrival: new Date(99, 11, 24),
		Date_of_Extraction: new Date(99, 11, 25),
		Date_of_Analysis: new Date(99, 11, 26),
	},
	{
		...baseReport,
		Analysis_No: "12350",
		Date_of_arrival: new Date(99, 11, 24),
		Date_of_Extraction: new Date(99, 11, 25),
		Date_of_Analysis: new Date(99, 11, 26),
	},
	{
		...baseReport,
		Analysis_No: "12351",
		Date_of_arrival: new Date(99, 11, 24),
		Date_of_Extraction: new Date(99, 11, 25),
		Date_of_Analysis: new Date(99, 11, 26),
	},
	{
		...baseReport,
		Analysis_No: "12352",
		Date_of_arrival: new Date(99, 11, 24),
		Date_of_Extraction: new Date(99, 11, 25),
		Date_of_Analysis: new Date(99, 11, 26),
	},
	{
		...baseReport,
		Analysis_No: "12353",
		Date_of_arrival: new Date(99, 11, 24),
		Date_of_Extraction: new Date(99, 11, 25),
		Date_of_Analysis: new Date(99, 11, 26),
	},
	{
		...baseReport,
		Analysis_No: "12354",
		Date_of_arrival: new Date(99, 11, 24),
		Date_of_Extraction: new Date(99, 11, 25),
		Date_of_Analysis: new Date(99, 11, 26),
	},
	{
		...baseReport,
		Analysis_No: "12355",
		Date_of_arrival: new Date(99, 11, 24),
		Date_of_Extraction: new Date(99, 11, 25),
		Date_of_Analysis: new Date(99, 11, 26),
	},
	{
		...baseReport,
		Analysis_No: "12356",
		Date_of_arrival: new Date(99, 11, 24),
		Date_of_Extraction: new Date(99, 11, 25),
		Date_of_Analysis: new Date(99, 11, 26),
	},
	{
		...baseReport,
		Analysis_No: "12357",
		Date_of_arrival: new Date(99, 11, 24),
		Date_of_Extraction: new Date(99, 11, 25),
		Date_of_Analysis: new Date(99, 11, 26),
	},
	{
		...baseReport,
		Analysis_No: "12358",
		Date_of_arrival: new Date(99, 11, 24),
		Date_of_Extraction: new Date(99, 11, 25),
		Date_of_Analysis: new Date(99, 11, 26),
	},
	{
		...baseReport,
		Analysis_No: "12359",
		Date_of_arrival: new Date(99, 11, 24),
		Date_of_Extraction: new Date(99, 11, 25),
		Date_of_Analysis: new Date(99, 11, 26),
	},
	{
		...baseReport,
		Analysis_No: "12360",
		Date_of_arrival: new Date(99, 11, 24),
		Date_of_Extraction: new Date(99, 11, 25),
		Date_of_Analysis: new Date(99, 11, 26),
	},
	{
		...baseReport,
		Analysis_No: "12361",
		Date_of_arrival: new Date(99, 11, 24),
		Date_of_Extraction: new Date(99, 11, 25),
		Date_of_Analysis: new Date(99, 11, 26),
	},
	{
		...baseReport,
		Analysis_No: "123562",
		Date_of_arrival: new Date(99, 11, 24),
		Date_of_Extraction: new Date(99, 11, 25),
		Date_of_Analysis: new Date(99, 11, 26),
	},
	{
		...baseReport,
		Analysis_No: "12363",
		Date_of_arrival: new Date(99, 11, 24),
		Date_of_Extraction: new Date(99, 11, 25),
		Date_of_Analysis: new Date(99, 11, 26),
	},
	{
		...baseReport,
		Analysis_No: "123564",
		Date_of_arrival: new Date(99, 11, 24),
		Date_of_Extraction: new Date(99, 11, 25),
		Date_of_Analysis: new Date(99, 11, 26),
	},
];

export const berichtPdfURL: UrlObject = {
	url: "/assets/Muster Analyseprotokoll.pdf",
};
export const pvPdfURL: UrlObject = {
	url: "/assets/Muster Prüfvorschrift.pdf",
};

export const baseReportData: Partial<BackendReport> = {
	Component_No: "45678",
	Component: "Batteriezelle",
	Testing_Specification: "890123",
	Customer: "Muster GmbH",
	customer_no: "12345",
	Filter_Type: "15 μm",
	filter_diameter: "22mm",
	Parts_on_Filter: 1,
	Component_Surface_Area_cm2: 1000,
	Weight_mg: 15,
	Scale: "10px/μm",
	Evaluated_diameter_mm: 22,
	occupancy: 0.25,
	woF_5_15: 2048,
	woF_15_25: 1024,
	woF_25_50: 512,
	woF_50_100: 256,
	woF_100_150: 128,
	woF_150_200: 64,
	woF_200_400: 32,
	woF_400_600: 16,
	woF_600_1000: 8,
	woF_gt_1000: 4,
	woF_200_300: 2,
	woF_300_400: 1,
	woF_400_500: 0,
	woF_500_600: 0,
	woF_600_700: 0,
	woF_700_800: 0,
	woF_800_900: 0,
	woF_900_1000: 0,
	woF_1000_1500: 0,
	woF_1500_2000: 0,
	woF_2000_2500: 0,
	woF_2500_3000: 0,
	woF_gt_3000: 0,
	All_5_15: 4096,
	All_15_25: 2048,
	All_25_50: 1024,
	All_50_100: 512,
	All_100_150: 256,
	All_150_200: 128,
	All_200_400: 64,
	All_400_600: 32,
	All_600_1000: 16,
	All_gt_1000: 8,
	All_200_300: 4,
	All_300_400: 2,
	All_400_500: 1,
	All_500_600: 0,
	All_600_700: 0,
	All_700_800: 0,
	All_800_900: 0,
	All_900_1000: 0,
	All_1000_1500: 0,
	All_1500_2000: 0,
	All_2000_2500: 0,
	All_2500_3000: 0,
	All_gt_3000: 0,
	Met_5_15: 10,
	Met_15_25: 9,
	Met_25_50: 8,
	Met_50_100: 7,
	Met_100_150: 6,
	Met_150_200: 5,
	Met_200_400: 4,
	Met_400_600: 3,
	Met_600_1000: 2,
	Met_gt_1000: 1,
	Met_200_300: 0,
	Met_300_400: 0,
	Met_400_500: 0,
	Met_500_600: 0,
	Met_600_700: 0,
	Met_700_800: 0,
	Met_800_900: 0,
	Met_900_1000: 0,
	Met_1000_1500: 0,
	Met_1500_2000: 0,
	Met_2000_2500: 0,
	Met_2500_3000: 0,
	Met_gt_3000: 0,

	woFNM_1L: 352,
	woFNM_1W: 42,
	woFNM_2L: 232,
	woFNM_2W: 31,
	woFNM_3L: 199,
	woFNM_3W: 40,
	woFNM_4L: 189,
	woFNM_4W: 39,
	woFNM_5L: 180,
	woFNM_5W: 37,
	Met_1L: 1001,
	Met_1W: 150,
	Met_2L: 840,
	Met_2W: 200,
	Met_3L: 740,
	Met_3W: 109,
	Met_4L: 640,
	Met_4W: 10,
	Met_5L: 606,
	Met_5W: 50,

	Fib_Fmax1_Fmax: 20,
	Fib_Fmax1_Lstr: 1000,
	Fib_Fmax2_Fmax: 25,
	Fib_Fmax2_Lstr: 850,

	Fib_Fmax_Sum_um: 1000,
	Fib_Stretched_Sum_um: 1000,
	woF_weighted_sum: 1000,
	All_weighted_sum: 1000,
	Met_weighted_sum: 1000,
	artsuch: "Musterbauteil",
	artnr: 890123,
	bemmem: "Saugextraktion",
	artbez1: "Werksnorm XY",
	artbez2: "- 23",

	zeichnr: "Musterbauteil",
	zeichindex: "1234",
	ioResult: true,
	is_fallback: false,
	filtersize: "22mm",
	met_sum: 10000,
	nm_sum: 10000,
	fibers_sum: 10000,
	katseite: "Musterbauteil",
};
export const bauteilVergleichData: Partial<BackendReport>[] = [
	{
		...baseReportData,
		Analysis_No: "12345",
		Date_of_arrival: new Date(99, 11, 24),
		Date_of_Extraction: new Date(99, 11, 25),
		Date_of_Analysis: new Date(99, 11, 26),
		new: true,
	},
	{
		...baseReportData,
		Analysis_No: "12346",
		Date_of_arrival: new Date(99, 11, 24),
		Date_of_Extraction: new Date(99, 11, 25),
		Date_of_Analysis: new Date(99, 11, 26),
		new: true,
	},
	{
		...baseReportData,
		Analysis_No: "12347",
		Date_of_arrival: new Date(99, 11, 24),
		Date_of_Extraction: new Date(99, 11, 25),
		Date_of_Analysis: new Date(99, 11, 26),
	},
	{
		...baseReportData,
		Analysis_No: "12348",
		Date_of_arrival: new Date(99, 11, 24),
		Date_of_Extraction: new Date(99, 11, 25),
		Date_of_Analysis: new Date(99, 11, 26),
	},
	{
		...baseReportData,
		Analysis_No: "12349",
		Date_of_arrival: new Date(99, 11, 24),
		Date_of_Extraction: new Date(99, 11, 25),
		Date_of_Analysis: new Date(99, 11, 26),
	},
	{
		...baseReportData,
		Analysis_No: "12350",
		Date_of_arrival: new Date(99, 11, 24),
		Date_of_Extraction: new Date(99, 11, 25),
		Date_of_Analysis: new Date(99, 11, 26),
	},
	{
		...baseReportData,
		Analysis_No: "12351",
		Date_of_arrival: new Date(99, 11, 24),
		Date_of_Extraction: new Date(99, 11, 25),
		Date_of_Analysis: new Date(99, 11, 26),
	},
	{
		...baseReportData,
		Analysis_No: "12352",
		Date_of_arrival: new Date(99, 11, 24),
		Date_of_Extraction: new Date(99, 11, 25),
		Date_of_Analysis: new Date(99, 11, 26),
	},
	{
		...baseReportData,
		Analysis_No: "12353",
		Date_of_arrival: new Date(99, 11, 24),
		Date_of_Extraction: new Date(99, 11, 25),
		Date_of_Analysis: new Date(99, 11, 26),
	},
	{
		...baseReportData,
		Analysis_No: "12354",
		Date_of_arrival: new Date(99, 11, 24),
		Date_of_Extraction: new Date(99, 11, 25),
		Date_of_Analysis: new Date(99, 11, 26),
	},
	{
		...baseReportData,
		Analysis_No: "12355",
		Date_of_arrival: new Date(99, 11, 24),
		Date_of_Extraction: new Date(99, 11, 25),
		Date_of_Analysis: new Date(99, 11, 26),
	},
	{
		...baseReportData,
		Analysis_No: "12356",
		Date_of_arrival: new Date(99, 11, 24),
		Date_of_Extraction: new Date(99, 11, 25),
		Date_of_Analysis: new Date(99, 11, 26),
	},
	{
		...baseReportData,
		Analysis_No: "12357",
		Date_of_arrival: new Date(99, 11, 24),
		Date_of_Extraction: new Date(99, 11, 25),
		Date_of_Analysis: new Date(99, 11, 26),
	},
	{
		...baseReportData,
		Analysis_No: "12358",
		Date_of_arrival: new Date(99, 11, 24),
		Date_of_Extraction: new Date(99, 11, 25),
		Date_of_Analysis: new Date(99, 11, 26),
	},
	{
		...baseReportData,
		Analysis_No: "12359",
		Date_of_arrival: new Date(99, 11, 24),
		Date_of_Extraction: new Date(99, 11, 25),
		Date_of_Analysis: new Date(99, 11, 26),
	},
	{
		...baseReportData,
		Analysis_No: "12360",
		Date_of_arrival: new Date(99, 11, 24),
		Date_of_Extraction: new Date(99, 11, 25),
		Date_of_Analysis: new Date(99, 11, 26),
	},
	{
		...baseReportData,
		Analysis_No: "12361",
		Date_of_arrival: new Date(99, 11, 24),
		Date_of_Extraction: new Date(99, 11, 25),
		Date_of_Analysis: new Date(99, 11, 26),
	},
	{
		...baseReportData,
		Analysis_No: "12362",
		Date_of_arrival: new Date(99, 11, 24),
		Date_of_Extraction: new Date(99, 11, 25),
		Date_of_Analysis: new Date(99, 11, 26),
	},
	{
		...baseReportData,
		Analysis_No: "12363",
		Date_of_arrival: new Date(99, 11, 24),
		Date_of_Extraction: new Date(99, 11, 25),
		Date_of_Analysis: new Date(99, 11, 26),
	},
	{
		...baseReportData,
		Analysis_No: "12364",
		Date_of_arrival: new Date(99, 11, 24),
		Date_of_Extraction: new Date(99, 11, 25),
		Date_of_Analysis: new Date(99, 11, 26),
	},
];
export const bauteilGridData: BauteilEntry[] = [
	{
		artnr: "890123",
		artsuch: "Batteriezelle",
		anzahl: 10,
		zeichnr: "Musterbauteil",
		zeichindex: "1234",
		katseite: "",
	},
	{
		artnr: "890123",
		artsuch: "Batteriezelle",
		anzahl: 10,
		zeichnr: "Musterbauteil",
		zeichindex: "1234",
		katseite: "",
	},
	{
		artnr: "890123",
		artsuch: "Batteriezelle",
		anzahl: 10,
		zeichnr: "Musterbauteil",
		zeichindex: "1234",
		katseite: "",
	},
	{
		artnr: "890123",
		artsuch: "Batteriezelle",
		anzahl: 10,
		zeichnr: "Musterbauteil",
		zeichindex: "1234",
		katseite: "",
	},
	{
		artnr: "890123",
		artsuch: "Batteriezelle",
		anzahl: 10,
		zeichnr: "Musterbauteil",
		zeichindex: "1234",
		katseite: "",
	},
	{
		artnr: "890123",
		artsuch: "Batteriezelle",
		anzahl: 10,
		zeichnr: "Musterbauteil",
		zeichindex: "1234",
		katseite: "",
	},
	{
		artnr: "890123",
		artsuch: "Batteriezelle",
		anzahl: 10,
		zeichnr: "Musterbauteil",
		zeichindex: "1234",
		katseite: "",
	},
	{
		artnr: "890123",
		artsuch: "Batteriezelle",
		anzahl: 10,
		zeichnr: "Musterbauteil",
		zeichindex: "1234",
		katseite: "",
	},
	{
		artnr: "890123",
		artsuch: "Batteriezelle",
		anzahl: 10,
		zeichnr: "Musterbauteil",
		zeichindex: "1234",
		katseite: "",
	},
];
